<ion-header>
  <ion-toolbar>
    <ion-title>
      Imprimir tickets
    </ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="closeModal()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>

  </ion-toolbar>

</ion-header>

<ion-content>
  <div #printContent id="print-content" class="ion-padding">
    <div class="ticket-content ion-margin-top ion-margin-bottom ion-text-center" *ngFor="let ticket of tickets">

      <h1 class="ion-text-center">
        {{channelName}}
      </h1>
      <div style="border-bottom: 1px solid;margin-top: 16px;margin-bottom: 16px; width: 90%;"></div>

      <h2 class="ion-text-center">
        {{contest.name}}
      </h2>

      <div style="border-bottom: 1px solid;margin-top: 16px;margin-bottom: 16px; width: 90%;"></div>

      <p class="ion-text-center ion-no-margin ion-margin-top">
        <b>Número de ticket:</b> {{ticket.id}}
      </p>
      <p class="ion-text-center ion-no-margin ion-margin-bottom">
        {{ticket.created | date:'yyyy/MM/dd HH:mm'}}
      </p>

      <div *ngIf="userInformation" class="ion-margin-top ion-margin-bottom">
        <p class="ion-text-center ion-no-margin">
          {{userInformation.first_name}} {{userInformation.last_name}}
        </p>
      </div>
      <div *ngIf="!userInformation" class="ion-margin-top ion-margin-bottom ion-text-center">
        <ion-spinner name="crescent"></ion-spinner>
      </div>

      <div style="border-bottom: 1px solid;margin-top: 16px;margin-bottom: 16px; width: 90%;"></div>

      <div [innerHTML]="contest.ticket_print_message"></div>

      <!-- Agrega el salto de página después de cada ticket -->
      <div class="page-break"></div>
    </div>
  </div>

</ion-content>


<ion-footer>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button (click)="customPrint()">
        Imprimir
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>